/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageContentFragment, PageContentFragment, FullPageContentFragment} from '@amblique/contentful/app/contentful/fragments/page-content';

/**
 * Get a single PageContent by ID (base - scalars only)
 */
export const getBasePageContentById = gql`
  ${BasePageContentFragment}

  query GetBasePageContentById($id: String!, $locale: String!, $preview: Boolean) {
    pageContent(id: $id, locale: $locale, preview: $preview) {
      ...BasePageContentFragment
    }
  }
`;

/**
 * Get a single PageContent by ID (standard - 1 level deep)
 */
export const getPageContentById = gql`
  ${PageContentFragment}

  query GetPageContentById($id: String!, $locale: String!, $preview: Boolean) {
    pageContent(id: $id, locale: $locale, preview: $preview) {
      ...PageContentFragment
    }
  }
`;

/**
 * Get a single PageContent by ID (full - 2 levels deep)
 */
export const getFullPageContentById = gql`
  ${FullPageContentFragment}

  query GetFullPageContentById($id: String!, $locale: String!, $preview: Boolean) {
    pageContent(id: $id, locale: $locale, preview: $preview) {
      ...FullPageContentFragment
    }
  }
`;

/**
 * Get all PageContent entries with pagination (base - scalars only)
 */
export const getBasePageContents = gql`
  ${BasePageContentFragment}

  query GetBasePageContents(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PageContentOrder]
    $where: PageContentFilter
    $preview: Boolean
  ) {
    pageContentCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BasePageContentFragment
      }
    }
  }
`;

/**
 * Get all PageContent entries with pagination (standard - 1 level deep)
 */
export const getPageContents = gql`
  ${PageContentFragment}

  query GetPageContents(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PageContentOrder]
    $where: PageContentFilter
    $preview: Boolean
  ) {
    pageContentCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...PageContentFragment
      }
    }
  }
`;

/**
 * Get all PageContent entries with pagination (full - 2 levels deep)
 */
export const getFullPageContents = gql`
  ${FullPageContentFragment}

  query GetFullPageContents(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PageContentOrder]
    $where: PageContentFilter
    $preview: Boolean
  ) {
    pageContentCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullPageContentFragment
      }
    }
  }
`;
